import React, { Component } from "react";
import axios from "axios";

import domain from ".././../../../domain";

import { Button } from "mdbreact";
import { Row, Col, Card, CardBody } from "mdbreact";
import ViewScheduleTable from "./ViewScheduleTable";

const moment = require("moment-timezone");
// function indexN(cell, row, enumObject, index) {
//     return (<div>{index+1}</div>)
// }
// function dateFormatter(cell) {
//  return moment(cell).tz("Asia/Kolkata").format("MM/DD/YYYY")

// }

class SessionFeedbackByCourseId extends Component {
  constructor() {
    super();
    this.state = {
      sessions: [],
      course_id: "",
      course_name: "",
      status: "",
      button_id: null,
    };
  }

  componentDidMount() {
    this.getSessions();
    this.getCourse();
  }

  async getCourse() {
    let courseId = this.props.match.params.id;
    let result = await axios.get(`${domain.DBServer}/fetch-course/${courseId}`);
    this.setState({
      course_name: result.data[0].title,
      status: result.data[0].status,
    });
  }

  getSessions() {
    let courseId = this.props.match.params.id;
    axios
      .get(`${domain.DBServer}/fetch-sessions/${courseId}`)
      .then((response) => {
        console.log(response.data);
        this.setState(
          {
            sessions: response.data,
            course_id: response.data[0].course_id,
            button_id: response.data[0].session_date,
          },
          () => {}
        );
      })
      .catch((err) => console.log(err));
  }
  handleChange = (e) => {
    e.preventDefault();
    //  let sessions

    this.setState({
      button_id: e.target.value,
    });
  };

  render() {
    //  let sessions
    let buttons = [];
    // let days
    let i = 0;
    let map1 = new Map();

    if (this.state.sessions) {
      this.state.sessions.map((course, key) => {
        map1.set(course.session_date, key);
        return true;
      });
    }

    console.log(map1.keys());
    for (let key of map1.keys()) {
      buttons[i++] = (
        <Button value={key} key={key} onClick={this.handleChange.bind(this)}>
          {moment(key).format("DD-MM-YYYY")}
        </Button>
      );
    }

    return (
      <div>
        <Row>
          <Col md="12">
            <Card>
              <CardBody>
                <h3 style={{ textAlign: "center", color: "blue" }}>
                  {this.state.course_name}
                </h3>
                <h4 style={{ textAlign: "center", color: "blue" }}>
                  List of Sessions
                </h4>
                {buttons}
                <table
                  className="table table-striped table-bordered table-responsive-md"
                  cellSpacing="0"
                  width="100%"
                >
                  <thead
                    style={{ textAlign: "center", backgroundColor: "#33b5e5" }}
                  >
                    <tr>
                      <th scope="col" width="20">
                        Lecture No
                      </th>
                      <th scope="col" width="50">
                        Lecturer Name
                      </th>
                      <th scope="col" width="100">
                        Title of the Session
                      </th>
                      <th scope="col" width="100">
                        Date{" "}
                      </th>
                      <th scope="col" width="50">
                        Start Time
                      </th>
                      <th scope="col" width="50">
                        End Date
                      </th>

                      <th scope="col" width="20">
                        View Feedback Report
                      </th>
                      <th scope="col" width="250">
                        View Summary Report
                      </th>
                    </tr>
                  </thead>

                  <ViewScheduleTable
                    button_date={this.state.button_id}
                    session_details={this.state.sessions}
                    course_id={this.props.match.params.id}
                    course_name={this.state.course_name}
                  />
                </table>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

export default SessionFeedbackByCourseId;
